import React, { useCallback, memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import Cookies from 'js-cookie'
import { func } from 'prop-types'

import { useIs3dPrintModel } from 'Pods/ItemPage/TopSection/hooks'

function ParentalLockMedia({ setShouldDisplayParentalLockOverlay }) {
  const is3dPrintModel = useIs3dPrintModel()
  const url = is3dPrintModel ? '/3d-print-models' : '/3d-models'

  const handleClose = useCallback(() => {
    window.location.href = url
  }, [url])

  const handleAdultClick = useCallback(() => {
    Cookies.set('i_am_an_adult', true)
    setShouldDisplayParentalLockOverlay(false)
  }, [setShouldDisplayParentalLockOverlay])

  return (
    <div className="parental-lock-media">
      You're about to view adult content. Please confirm your age.
      <div className="parental-lock-media__content">
        <Button
          size="small"
          type="secondary"
          onClick={handleClose}
        >
          Leave this page
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={handleAdultClick}
        >
          I'm an adult, continue
        </Button>
      </div>
    </div>
  )
}

ParentalLockMedia.propTypes = {
  setShouldDisplayParentalLockOverlay: func.isRequired,
}

export default memo(ParentalLockMedia)
